const getDefaultState = () => {
    return {        
        primary: {
            hasDamage: false,
            diceQuantity: '1',
            diceSides: '6',
            staticBonus: '',
            addStatMod: true,                
            type: '',
            isBrutal: false,
            brutalValue: '',
        },
        secondary: {
            hasDamage: false,
            diceQuantity: '1',
            diceSides: '6',
            staticBonus: '',
            addStatMod: true,
            type: '',
            isBrutal: false,
            brutalValue: '',
        },
        tertiary: {
            hasDamage: false,
            diceQuantity: '1',
            diceSides: '6',
            staticBonus: '',
            addStatMod: true,
            type: '',
            isBrutal: false,
            brutalValue: '',
        },
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {        
        resetState: (state) => Object.assign(state, getDefaultState()),
        setHasDamage: (state, value) => state.primary.hasDamage = value,        
        setDiceQuantity: (state, value) => state.primary.diceQuantity = value,
        setDiceSides: (state, value) => state.primary.diceSides = value,
        setStaticBonus: (state, value) => state.primary.staticBonus = value,
        setAddStatMod: (state, value) => state.primary.addStatMod = value,        
        setType: (state, value) => state.primary.type = value,
        setIsBrutal: (state, value) => state.primary.isBrutal = value,
        setBrutalValue: (state, value) => state.primary.brutalValue = value,
        setSecondaryHasDamage: (state, value) => state.secondary.hasDamage = value,
        setSecondaryDiceQuantity: (state, value) => state.secondary.diceQuantity = value,
        setSecondaryDiceSides: (state, value) => state.secondary.diceSides = value,
        setSecondaryStaticBonus: (state, value) => state.secondary.staticBonus = value,
        setSecondaryAddStatMod: (state, value) => state.secondary.addStatMod = value,
        setSecondaryType: (state, value) => state.secondary.type = value,
        setSecondaryIsBrutal: (state, value) => state.secondary.isBrutal = value,
        setSecondaryBrutalValue: (state, value) => state.secondary.brutalValue = value,
        setTertiaryHasDamage: (state, value) => state.tertiary.hasDamage = value,
        setTertiaryDiceQuantity: (state, value) => state.tertiary.diceQuantity = value,
        setTertiaryDiceSides: (state, value) => state.tertiary.diceSides = value,
        setTertiaryStaticBonus: (state, value) => state.tertiary.staticBonus = value,
        setTertiaryAddStatMod: (state, value) => state.tertiary.addStatMod = value,
        setTertiaryType: (state, value) => state.tertiary.type = value,
        setTertiaryIsBrutal: (state, value) => state.tertiary.isBrutal = value,
        setTertiaryBrutalValue: (state, value) => state.tertiary.brutalValue = value,
    },
}